import { api } from '@/scripts/api'

export interface SkillMeta {
  name: string
  description: string
  configSchema: Record<string, unknown>
  inputSchema: Record<string, unknown>
  outputSchema: Record<string, unknown>
  aiPrompt?: string
  createdAt?: string
}

export interface GeneratedSkill {
  name?: string
  description?: string
  config_schema?: Record<string, unknown>
  input_schema?: Record<string, unknown>
  output_schema?: Record<string, unknown>
  code?: string
}

interface ApiEnvelope<T> {
  ok: boolean
  error?: string
  raw?: string
  item?: T
  items?: T[]
  code?: string
}

async function request<T>(
  path: string,
  init?: RequestInit
): Promise<ApiEnvelope<T>> {
  const res = await api.fetchApi(path, {
    headers: { 'Content-Type': 'application/json' },
    ...init
  })
  try {
    return (await res.json()) as ApiEnvelope<T>
  } catch {
    return { ok: false, error: `HTTP ${res.status}` }
  }
}

export const skillsApi = {
  list: () => request<SkillMeta>('/skills'),
  get: (name: string) => request<SkillMeta>(`/skills/${encodeURIComponent(name)}`),
  save: (skill: {
    name: string
    description: string
    config_schema: Record<string, unknown>
    input_schema: Record<string, unknown>
    output_schema: Record<string, unknown>
    ai_prompt: string
    code: string
  }) => request<SkillMeta>('/skills', { method: 'POST', body: JSON.stringify(skill) }),
  remove: (name: string) =>
    request<never>(`/skills/${encodeURIComponent(name)}`, { method: 'DELETE' }),
  generate: (prompt: string) =>
    request<GeneratedSkill>('/skills/generate', {
      method: 'POST',
      body: JSON.stringify({ prompt })
    }),
  reloadNodes: () => request<never>('/nodes/reload', { method: 'POST' })
}
